export const getRef = () => {
  try {
    return localStorage.getItem("ozentya_ref") || null;
  } catch {
    return null;
  }
};

export const setRef = (code) => {
  try {
    if (code) localStorage.setItem("ozentya_ref", String(code).toUpperCase());
  } catch {
    /* ignore */
  }
};
